import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AddressCard from '../AddressCard';
import SavedAccountAddress from './SavedAccountAddress';
import JunoButton from '../common/JunoButton';
import { Add } from '@mui/icons-material';
import PayOut from '../TransactionForm/PayOut/PayOut';
import EmptyCardState from '../common/EmptyCardState';
import clsx from 'clsx';
import { fiatCurrencyList } from '../../helpers/constant';

const SavedBankAcountCards = ({
    addNewAccount,
    openAccountModal,
    savedAccounts = [],
    onDeleteAccount,
    accountsPage,
}) => {
    const navigate = useNavigate();
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [showAddressModal, setShowAddressModal] = useState(false);
    const [openPayoutModal, setPayoutModal] = useState({ status: false });
    const clientData = useSelector(state => state.juno.clientData);
    const { readOnly } = clientData || {};

    const handleSeeAll = () => {
        navigate('/client/accounts');
    };

    const handleOpenAccountModal = account => {
        setSelectedAccount(account);
        setShowAddressModal(true);
    };

    const handleCloseModal = () => {
        setShowAddressModal(false);
        setSelectedAccount(null);
    };

    const handleEditAccount = account => {
        if (openAccountModal) {
            openAccountModal(account);
        }
    };

    const handleDeleteAccount = account => {
        // Close the address modal first
        setShowAddressModal(false);
        setSelectedAccount(null);
        // Then trigger the delete from parent
        if (onDeleteAccount) {
            onDeleteAccount(account);
        }
    };

    const handlePayout = (type, account = {}) => {
        let selectedCurrency = fiatCurrencyList?.find(
            balance => balance.currencyShortName == account.currency,
        );

        setShowAddressModal(false);
        setPayoutModal(() => ({
            type,
            selectedAccount: { ...account, selectedCurrency },
            status: true,
        }));
    };

    return (
        <div
            className={`!p-4 md:!p-6 rounded-lg !border-section-br bg-[#FFF] dark:bg-[#26272B] rounded-b-lg lg:border-0 md:border md:!border-section-br ${!accountsPage ? 'border' : ''}`}
            style={{ height: accountsPage ? 'calc(100vh - 75px)' : '' }}>
            <div className={`flex items-center justify-between ${!accountsPage && 'mb-3'}`}>
                {!accountsPage && (
                    <>
                        <Typography
                            variant="subtitle1"
                            className="text-section-title !text-sm !font-semibold !font-inter">
                            SAVED BANK ACCOUNTS
                            {savedAccounts.length ? (
                                <span
                                    className="text-center w-4 h-4  flex-col  bg-gray-200 dark:bg-[#51525C]
                            !text-primary font-inter text-[14px] font-semibold ml-1 px-2 py-1 rounded-md">
                                    {savedAccounts.length}
                                </span>
                            ) : null}
                        </Typography>
                        {savedAccounts.length ? (
                            <Add
                                className={clsx(
                                    'text-balanceCard-manage cursor-pointer lg:!hidden',
                                    // readOnly && 'opacity-50',
                                )}
                                onClick={readOnly ? null : addNewAccount}
                            />
                        ) : null}
                    </>
                )}
                {accountsPage && (
                    <div className="hidden lg:flex">
                        <Typography
                            variant="subtitle1"
                            className="text-section-title !text-sm !font-semibold mb-3 !font-inter">
                            SAVED BANK ACCOUNTS
                            {savedAccounts.length ? (
                                <span
                                    className="text-center w-4 h-4  flex-col  bg-gray-200 dark:bg-[#51525C]
                            !text-primary font-inter text-[14px] font-semibold ml-1 px-2 py-1 rounded-md">
                                    {savedAccounts.length}
                                </span>
                            ) : null}
                        </Typography>
                        {savedAccounts.length ? (
                            <Add
                                className={clsx(
                                    'text-balanceCard-manage cursor-pointer lg:!hidden',
                                    // readOnly && 'opacity-50',
                                )}
                                onClick={readOnly ? null : addNewAccount}
                            />
                        ) : null}
                    </div>
                )}

                {!accountsPage && savedAccounts.length ? (
                    <JunoButton
                        className="!w-[66px] text-xs !p-0 !h-7 font-semibold hidden lg:block"
                        type="secondary"
                        onClick={handleSeeAll}>
                        See all
                    </JunoButton>
                ) : null}
            </div>

            {savedAccounts?.length === 0 ? (
                <div
                    className={`${accountsPage ? 'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-6' : 'w-full py-4 grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-1'}`}>
                    {accountsPage && (
                        <p className="text-text text-sm font-semibold text-center uppercase">
                            There are no bank accounts yet.
                        </p>
                    )}
                    <EmptyCardState
                        cardHeading={'ADD BANK ACCOUNT'}
                        onClick={readOnly ? null : addNewAccount}
                        className={`${accountsPage ? 'w-[320px]' : 'h-[132px]'}`}
                        readOnly={readOnly}
                    />
                </div>
            ) : (
                <div
                    className={
                        'grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-1'
                    }>
                    <div className="hidden lg:block">
                        <EmptyCardState
                            cardHeading={'ADD BANK ACCOUNT'}
                            onClick={readOnly ? null : addNewAccount}
                            className="h-[132px]"
                            readOnly={readOnly}
                        />
                    </div>

                    {savedAccounts.map((account, index) => {
                        const currency = fiatCurrencyList.find(
                            x => x.currencyShortName === account.currency,
                        );

                        return (
                            <AddressCard
                                key={account._id || index}
                                onClick={() => handleOpenAccountModal(account)}
                                wallet={{
                                    ...account,
                                    currancyIcon: currency?.currencyIcon,
                                }}
                                readOnly={readOnly}
                            />
                        );
                    })}
                </div>
            )}
            {!accountsPage && savedAccounts.length ? (
                <JunoButton
                    className="py-[12px] mt-3 font-semibold text-center rounded borrounded-mdder-none bg-gray-200 text-gray-900 w-full lg:hidden"
                    type="secondary"
                    onClick={handleSeeAll}>
                    See all
                </JunoButton>
            ) : null}

            {showAddressModal && selectedAccount && (
                <SavedAccountAddress
                    open={showAddressModal}
                    onClose={handleCloseModal}
                    data={selectedAccount}
                    onEdit={handleEditAccount}
                    onDeleteAccount={handleDeleteAccount}
                    handlePayout={handlePayout}
                />
            )}

            {openPayoutModal?.status ? (
                <PayOut
                    isModal={true}
                    {...openPayoutModal}
                    onClose={() => {
                        setShowAddressModal(true);
                        setPayoutModal({ status: false });
                    }}
                    fromAddress={true}
                />
            ) : null}
        </div>
    );
};

export default SavedBankAcountCards;
